import { useLayoutEffect } from 'react'

/** Explicit screen identity only: never pass dates/options/loading state here. */
export function enterBookingScreen(root, { includeAncestors = true } = {}) {
  if (!root) return
  const containers = [root, ...root.querySelectorAll('*')]
  let parent = includeAncestors ? root.parentElement : null
  while (parent) { containers.push(parent); parent = parent.parentElement }
  for (const element of containers) {
    if (element.scrollTop) {
      const behavior = element.style.scrollBehavior
      element.style.scrollBehavior = 'auto'
      element.scrollTop = 0
      element.style.scrollBehavior = behavior
    }
  }
  // Responsive Members views can retain a hidden desktop heading. Focusing
  // that node silently fails in WebKit/Chromium and leaves focus on the link.
  const heading = [...root.querySelectorAll('h1, h2, h3, h4, [role="heading"]')].find(target => {
    if (target.matches('a[href], button, input, textarea, select, [contenteditable], [role=button], [role=link]')) return false
    if (target.closest('[hidden], [inert], [aria-hidden="true"]')) return false
    for (let element = target; element; element = element.parentElement) {
      const style = window.getComputedStyle(element)
      if (style.display === 'none' || style.visibility === 'hidden') return false
    }
    return true
  }) || root
  focusMemberScreenTarget(heading)
}

/** Restore a static screen target as well as ordinary interactive dialog openers. */
export function focusMemberScreenTarget(target) {
  if (!target) return
  const interactive = target.matches('a[href], button, input, textarea, select, [contenteditable], [role=button], [role=link]')
  if (interactive) { target.focus({ preventScroll: true }); return }
  target.setAttribute('data-mp-static-focus', '')
  const hadTabIndex = target.hasAttribute('tabindex')
  if (!hadTabIndex) target.setAttribute('tabindex', '-1')
  target.focus({ preventScroll: true })
  if (!hadTabIndex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true })
}

export function useBookingScreenEntry(screenKey, rootRef) {
  useLayoutEffect(() => {
    const root = rootRef ? rootRef.current : document.querySelector('.mp-main')
    enterBookingScreen(root, { includeAncestors: !rootRef })
  }, [screenKey, rootRef])
}
